import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Button } from "react-bootstrap";
import { sessionActions } from "../../state/ducks/session";
import { sessionService } from "../../state/ducks/session/sessionService";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { ls } from "../../locale";

const MAX_AUTO_RETRIES = 2;

function LoadingError({ onRetry }) {
  return (
    <div>
      <p>The service is temporarily not available. Please try again later.</p>
      <Button onClick={onRetry}>Try again</Button>
    </div>
  );
}

function InitSession({ getSession, isLoading, children }) {
  const [attempts, setAttempts] = useState(0);

  // keep showing "Loading..." while auto-retries are still pending,
  // so transient failures don't flash the error page during backoff
  const retrying = isLoading || attempts < MAX_AUTO_RETRIES;

  useEffect(() => {
    if (sessionService.hasToken()) return;
    getSession().catch(() => {});
  }, [getSession]);

  // auto-retry with backoff after a failed attempt
  useEffect(() => {
    if (isLoading || sessionService.hasToken() || attempts >= MAX_AUTO_RETRIES) return;
    const timer = setTimeout(() => {
      setAttempts(n => n + 1);
      getSession().catch(() => {});
    }, 3000 * Math.pow(2, attempts));
    return () => clearTimeout(timer);
  }, [isLoading, attempts, getSession]);

  const handleRetry = () => {
    setAttempts(0);
    getSession().catch(() => {});
  };

  if (sessionService.hasToken()) return <>{children}</>;

  return (
    <div className={ls.t("rootClass") + " main-container search-page"} dir={ls.t("direction")}>
      <div className="header-con">
        <Header />
      </div>
      <div className="container padt80 padb20">
        <Row className="min-height">
          {retrying ? <>Loading...</> : <LoadingError onRetry={handleRetry} />}
        </Row>
      </div>
      <Footer />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    isLoading: state.session.isLoading
  };
}

const mapDispatchToProps = {
  getSession: sessionActions.getSession,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InitSession));
